/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 座席情報
 */
export interface JourneyElementSeat {
  /**
   * 座席番号（MCFのSSR RQSTの座席番号）
   */
  seatNumber?: string;
  /**
   * バシネット申込あり<br> 以下の条件を満たす場合にtrue<br> 1. 当該セグメントがNHグループ運航<br> 1. SSR BSCTが存在し、SSRステータスがMCF
   */
  isBassinetRequested: boolean;
  /**
   * チャイルドシート申込あり<br> 以下の条件を満たす場合にtrue<br> 1. 当該セグメントがNHグループ便名NHグループ運航 1. SK CHSTが存在する
   */
  isChildSeatRequested: boolean;
  /**
   * チャイルドシート種別。SK CHSTのフリーテキストに、それぞれの値が含まれている場合に返却する。<br> MLIT:日本の国土交通省(MLIT)承認<br> FMVSS:米国(FMVSS)承認<br> ECE:欧州(ECE R44/UN R44)承認<br> CARES:CARESのチャイルドシート
   */
  childSeatType?: JourneyElementSeat.ChildSeatTypeEnum;
  /**
   * 有料でカウチ席指定済み<br> 以下のいずれかの条件を満たす場合にtrue<br> - SK COUCが存在する<br> - 設定ファイルで定義した買い取りカウチ用のSKが存在する
   */
  isPaidCouchRequested: boolean;
}
export namespace JourneyElementSeat {
  export type ChildSeatTypeEnum = 'MLIT' | 'FMVSS' | 'ECE' | 'CARES';
  export const ChildSeatTypeEnum = {
    Mlit: 'MLIT' as ChildSeatTypeEnum,
    Fmvss: 'FMVSS' as ChildSeatTypeEnum,
    Ece: 'ECE' as ChildSeatTypeEnum,
    Cares: 'CARES' as ChildSeatTypeEnum,
  };
}
